"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = openURL;
function openURL(url) {
  window.open(url, '_blank', 'location=no, menubar=no, resizable=yes, scrollbars=yes, statusbar=no, status=no, titlebar=no, toolbar=no');
}